// What the app shows: the catches in memory, and the render hooks that redraw the screen when data changes.
import type { Catch } from "../shared/model.ts";

/** All catches, loaded from the database at start. Replace the whole list only with setCatches(). */
export let catches: Catch[] = [];
export function setCatches(list: Catch[]): void {
  catches = list;
}

const renderers: (() => void)[] = [];
/** Registers a part of the screen to redraw whenever catches, pins, groups or settings change. */
export function onRender(fn: () => void): void {
  renderers.push(fn);
}
/** Redraws every registered part of the screen. */
export function render(): void {
  for (const fn of renderers) fn();
}
